module.exports = __webpack_public_path__ + "static/media/oiran_dream.winfast.bbaf7e28.jpeg";